import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconBlankQuizSvg } from './IconBlankQuizSvg';

export type IconBlankQuizProps = UseIconProps;

export function IconBlankQuiz(props: IconBlankQuizProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <Box tagName={IconBlankQuizSvg} {...iconProps} />;
}
